import {Component, OnInit, ViewChild} from '@angular/core';
import { ApiService } from '../../api.service';
import {AvailableTagsComponent} from '../../tags/available-tags/available-tags.component';
import {TagsComponent} from '../../tags/tags.component';
import {TaggedBaseComponent} from '../../tags/tagged-base/tagged-base.component';

@Component({
  selector: 'app-list-birthdays',
  templateUrl: './list-birthdays.component.html',
  styleUrls: ['./list-birthdays.component.css']
})
export class ListBirthdaysComponent extends TaggedBaseComponent implements OnInit {
    selectedTags = [];
    public birthdays: any;
    public loaded = false;
    protected today: Date;
    public availableTags: any;
    public filtered;
    public currentsorting: string;
    public sortingOrder;
    constructor(  private apiService: ApiService ) {
        super('birthdays');
        this.sortingOrder = 'up';
        this.today = new Date();
        this.today.setHours(0, 0, 0, 0);
    }

    ngOnInit() {
        this.getBirthdays();
    }

    getBirthdays() {
        this.apiService.getAll('birthdays').subscribe(
            (value) => {
                this.loaded = true;
                this.birthdays = value;
                this.birthdays.map((birthday) => {
                    birthday.birthday = new Date(birthday.birthday);
                    birthday.daysUntil = this.daysUntil(birthday.birthday);
                    birthday.age = this.today.getFullYear() - birthday.birthday.getFullYear();
                    if (birthday.birthday.getMonth() < this.today.getMonth() ||
                        (
                            birthday.birthday.getMonth() === this.today.getMonth()
                            && birthday.birthday.getDate() < this.today.getDate()
                        )
                    ) {
                        birthday.age++;
                    }
                    return birthday;
                });
                this.filtered = this.birthdays;
            }
        );
    }

    deleteBirthday(id) {
        const confirmed = window.confirm('Are you sure?');
        if (confirmed) {
            this.apiService
                .deleteByID('birthdays', id)
                .toPromise()
                .then(
                    () => {
                        this.getBirthdays();
                    },
                    () => {
                        alert('deletion failed');
                    }
                );
        }
    }
    public daysUntil(birthday: Date) {
        console.log(birthday);
        console.log(typeof birthday);
        const bday = new Date(birthday);
        bday.setFullYear(this.today.getFullYear());
        bday.setHours(0, 0, 0, 0);
        if (bday < this.today) {
            console.log('today', this.today);
            console.log('bday', bday);
            bday.setFullYear(bday.getFullYear() + 1);
        }
        const dateDiff = bday.getTime() - this.today.getTime();
        const daysDiff = Math.round(dateDiff / 1000 / 3600 / 24);
        return daysDiff;
    }

    sortBy(attribute: string) {
        if (attribute === this.currentsorting) {
            this.sortingOrder = this.sortingOrder === 'up' ? 'down' : 'up';
        } else {
            this.sortingOrder = 'up';
        }
        this.currentsorting = attribute;
        switch (attribute) {
            case 'birthday':
                this.filtered = this.filtered.sort((a, b) => {
                    const aDay = new Date(a.birthday);
                    const bDay = new Date(b.birthday);
                    aDay.setFullYear(0);
                    bDay.setFullYear(0);
                    if (this.sortingOrder === 'up') {
                        return aDay > bDay ? 1 : -1;
                    }
                    return bDay > aDay ? 1 : -1;
                });
                break;
            default:
                this.filtered.sort((a, b) => {
                    if (this.sortingOrder === 'up') {
                        return a[attribute] > b[attribute] ? 1 : -1;
                    }
                    return b[attribute] > a[attribute] ? 1 : -1;
                });
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/birthdays/list-birthdays/list-birthdays.component.ts